/**
 * The brand lockup at the top of every pre-session card (sign in, sign up,
 * verify email, welcome) — round9/design-pass.
 *
 * One component instead of four copies of the same <header>, and the logo
 * is sized for a form rather than for a billboard: it was 260px tall on the
 * login card (taller than the whole form beneath it) and 180px on the
 * others. The tag under it is the one place the portal keeps an eyebrow,
 * because it carries information the heading does not: which plane you are
 * signing in to ("Builder portal" here, "Platform admin" on /admin/login).
 */
import { DOCKPRO_LOGO_URL } from "../lib/brand";
import styles from "./BrandHeader.module.css";

export function BrandHeader({ tag = "Builder portal" }: { tag?: string }) {
  return (
    <header className={styles.header}>
      <img src={DOCKPRO_LOGO_URL} alt="DockPro" className={styles.logo} width={72} height={72} />
      <p className={styles.tag}>{tag}</p>
    </header>
  );
}
